/* Meine Anlässe - /pages/anlaesse (sections/mhsys-anlaesse.liquid, Roadmap 3.47 Paket B). Geladen aus layout/theme.liquid
 * nur auf dieser Seite (template.suffix "anlaesse").
 *
 * Proxy (Paket A in mhsys, extern/kundeninhalte/anlass/), alle POST mit JSON an /apps/kunde?bereich=anlass&teil=…:
 *   vorlagen {}                              -> {ok, vorlagen:[…], einw_text}            (auch ohne Anmeldung)
 *   liste {}                                 -> {ok, anlaesse:[…], vorlagen:[…], einw_text}
 *   speichern {vorlage, name, tag, monat, id} -> wie liste, dazu gespeichert_id
 *   loeschen {id}                            -> wie liste
 *   push {kennung, an}                       -> wie liste; Push-Abo mit dem Kunden verknüpfen (an) oder lösen
 *   liste/speichern/loeschen bekommen die Push-Kennung dieses Geräts mit (kennung) und antworten zusätzlich mit
 *   push:true|false (dieses Gerät verknüpft und aktiv) und push_geraete:n (verknüpfte Geräte gesamt) - fehlt push,
 *   zeigt die Seite den Push-Teil nicht. Fehler "push" = Abo hier nicht aktiv, meldung wird angezeigt.
 * Vorlage: {vorlage, art, symbol, titel, frage, name, name_frei, name_platzhalter, mit_datum, finder, geschlecht_frage}
 * Anlass:  {id, art, vorlage, name, titel, tag, monat, geschlecht, naechster_termin, erinnerung_am, zu_nah, tage_bis}
 *          geschlecht "w" | "m" | "" - freiwillig, nur bei Vorlagen mit geschlecht_frage (Inhaber 29.09.2026, "Spotzl")
 * Fehler:  {ok:false, fehler:"<code>", meldung:"Satz für den Kunden"} - meldung wird angezeigt, fehler (anmeldung, daten, voll,
 *          doppelt, nicht_gefunden, grenze, intern) nur ausgewertet. Schnittstelle abgestimmt mit Paket A (Jonte, 29.09.2026).
 *
 * Gast tippt ein Kärtchen an: Fenster mit "Kurz anmelden"; die gewählte Vorlage liegt in sessionStorage (mhsysAnlOffen)
 * und öffnet sich nach der Anmeldung von selbst. Alle Werte nur per textContent.
 */
(function () {
  "use strict";
  var seite = document.querySelector("[data-anl-seite]");
  if (!seite) return;

  var kunde = seite.getAttribute("data-anl-kunde") === "1";
  var finderUrl = seite.getAttribute("data-anl-finder") || "";
  var karten = seite.querySelector("[data-anl-karten]");
  var meine = seite.querySelector("[data-anl-meine]");
  var liste = seite.querySelector("[data-anl-liste]");
  var fehlerZeile = seite.querySelector("[data-anl-fehler]");
  var fenster = seite.querySelector("[data-anl-fenster]");
  var form = seite.querySelector("[data-anl-form]");
  var f = {};
  ["symbol", "titel", "gast", "felder", "frage", "namenfeld", "name", "datumfeld", "tag", "monat", "geschlecht", "fest", "fehler", "einw", "senden"].forEach(function (n) {
    f[n] = seite.querySelector("[data-anl-f-" + n + "]");
  });

  var MONATE = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
  var TAGE_IM_MONAT = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  var EINW_ERSATZ = "Wir schicken dir zehn Werktage vorher eine Mail mit Ideen – abbestellen mit einem Klick.";
  var FEHLER_ALLG = "Grad hakt's bei uns – probier's gleich nochmal.";
  var SS_OFFEN = "mhsysAnlOffen";

  var stand = { vorlagen: [], anlaesse: [], einw: "", push: null, pushGeraete: 0 };
  var offen = null; // {vorlage, id}
  // Nur das eben gespeicherte Kärtchen dreht sich um, genau einmal: frisch gilt für das nächste Zeichnen und wird dabei
  // geleert. Vorher hing die Umdreh-Klasse an allen in dieser Sitzung gespeicherten - bei jedem Neuzeichnen drehten sie
  // sich alle wieder (Meldung des Inhabers 29.09.2026). Eingetragene zeigen ruhig einen Haken und ihr Datum.
  var frisch = "";

  // ---------------------------------------------------------------- Proxy
  function proxy(teil, daten) {
    daten = daten || {};
    // Die Push-Kennung dieses Geräts geht mit, damit mhsys "push" für genau dieses Gerät beantwortet (Jonte, 29.09.2026)
    if (kunde && teil !== "vorlagen" && teil !== "push" && !daten.kennung) {
      var k = geraetKennung();
      if (k) daten.kennung = k;
    }
    // Zeitlimit (layout/theme.liquid, Roadmap 7.44); ein Netzfehler zeigt den eigenen Satz, nie "Failed to fetch"
    return (window.mhsysNetz ? window.mhsysNetz.holen : fetch)("/apps/kunde?bereich=anlass&teil=" + teil, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(daten || {}),
      credentials: "same-origin",
      cache: "no-store",
    }).catch(function () {
      var e = new Error(FEHLER_ALLG);
      e.status = 0;
      e.code = "netz";
      throw e;
    }).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (a) {
        if (!r.ok || !a || !a.ok) {
          var e = new Error((a && a.meldung) || FEHLER_ALLG);
          e.status = r.status;
          e.code = (a && a.fehler) || "";
          throw e;
        }
        return a;
      });
    });
  }

  function uebernehmen(a) {
    if (Array.isArray(a.vorlagen) && a.vorlagen.length) stand.vorlagen = a.vorlagen;
    if (Array.isArray(a.anlaesse)) stand.anlaesse = a.anlaesse;
    if (a.einw_text) stand.einw = String(a.einw_text);
    if (typeof a.push === "boolean") stand.push = a.push;
    if (typeof a.push_geraete === "number") stand.pushGeraete = a.push_geraete;
    kartenZeichnen();
    listeZeichnen();
    pushZeichnen();
  }

  // ---------------------------------------------------------------- Push (Inhaber 29.09.2026)
  // E-Mail ist immer an; Push kommt freiwillig dazu. Abonniert wird über assets/mhsys-benachrichtigung.js
  // (window.mhsysPush, wie auf der Bestellstatus-Seite), mhsys verknüpft das Abo mit dem Kunden (teil=push {kennung, an}).
  // Solange mhsys kein "push" liefert oder das Push-Skript im Shop aus ist, bleibt der Platz leer. Nie still: ein schon
  // vorhandenes Abo wird erst nach dem Klick verknüpft.
  var pushPlatz = seite.querySelector("[data-anl-push]");
  var pushWartet = false;
  function pushWeg() {
    var p = window.mhsysPush;
    return p && typeof p === "object" && p.abonnieren ? p : null;
  }
  // Kennung des Push-Abos in diesem Browser - aus dem Push-Skript, oder (lädt es später) aus seinem Merker mhPush;
  // leer, wenn hier ausgeschaltet wurde (mhPushAus)
  function geraetKennung() {
    var weg = pushWeg(), abo = null, aus = false;
    try {
      abo = weg ? weg.abo() : JSON.parse(localStorage.getItem("mhPush") || "null");
      aus = weg ? weg.ausgeschaltet() : !!localStorage.getItem("mhPushAus");
    } catch (e) {}
    return !aus && abo && abo.kennung ? String(abo.kennung) : "";
  }
  function pushFehler(err) {
    pushVorlage("fehler");
    // "push": das Abo ist bei uns nicht (mehr) aktiv - mhsys sagt dann selbst, was zu tun ist
    var satz = pushPlatz.querySelector("[data-anl-push-fehlertext]");
    if (satz && err && err.code === "push" && err.message) satz.textContent = err.message;
  }
  function pushVorlage(name) {
    var v = seite.querySelector('template[data-anl-push-vorlage="' + name + '"]');
    pushPlatz.textContent = "";
    pushPlatz.hidden = !v;
    if (v) pushPlatz.appendChild(v.content.cloneNode(true));
    return v;
  }
  function pushZeichnen() {
    if (!pushPlatz || !kunde || typeof stand.push !== "boolean") return;
    var weg = pushWeg();
    if (!weg) {
      // das Push-Skript kommt noch (beide defer) - oder gar nicht, wenn Push im Shop aus ist: dann bleibt es leer
      if (!pushWartet) {
        pushWartet = true;
        document.addEventListener("mhsys:push-bereit", pushZeichnen, { once: true });
      }
      return;
    }
    if (weg.iphone) { pushVorlage("iphone"); return; }
    if (!weg.kann) { pushPlatz.hidden = true; return; }
    if (window.Notification && Notification.permission === "denied") { pushVorlage("blockiert"); return; }
    var abo = weg.abo();
    if (stand.push && abo && abo.kennung) {
      pushVorlage("an");
      var aus = pushPlatz.querySelector("[data-anl-push-aus]");
      if (aus) aus.addEventListener("click", function () {
        aus.disabled = true;
        proxy("push", { kennung: abo.kennung, an: false }).then(uebernehmen).catch(pushFehler);
      });
      return;
    }
    var v = pushVorlage("aus");
    var fassung = v ? v.getAttribute("data-fassung") : "";
    // auf einem anderen Gerät schon an: kurz sagen, dass es hier zusätzlich geht
    var andere = pushPlatz.querySelector("[data-anl-push-andere]");
    if (andere) andere.hidden = !(stand.pushGeraete > 0);
    var ein = pushPlatz.querySelector("[data-anl-push-ein]");
    if (!ein) return;
    ein.addEventListener("click", function () {
      ein.disabled = true;
      var vorhanden = weg.abo();
      // schon ein Abo in diesem Browser (und nicht ausgeschaltet): nur verknüpfen, nicht neu fragen
      var kennung = vorhanden && vorhanden.kennung && !weg.ausgeschaltet()
        ? Promise.resolve(vorhanden.kennung)
        // sonst die Browser-Nachfrage im selben Klick (Nutzeraktion), nie beim Laden der Seite
        : weg.erlaubnis().then(function (p) {
            if (p === "denied") { pushVorlage("blockiert"); return null; }
            if (p !== "granted") { ein.disabled = false; return null; }
            return weg.abonnieren("anlaesse", fassung).then(function (j) { return j && j.kennung; });
          });
      kennung
        .then(function (k) { if (k) return proxy("push", { kennung: k, an: true }).then(uebernehmen); })
        .catch(pushFehler);
    });
  }

  function fehler(text) {
    fehlerZeile.textContent = text || "";
    fehlerZeile.hidden = !text;
  }

  // ---------------------------------------------------------------- Hilfen
  function el(tag, klasse, text) {
    var e = document.createElement(tag);
    if (klasse) e.className = klasse;
    if (text != null) e.textContent = text;
    return e;
  }
  function datumLang(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || ""));
    if (!m) return "";
    return Number(m[3]) + ". " + MONATE[Number(m[2]) - 1];
  }
  function vorlage(kuerzel) {
    for (var i = 0; i < stand.vorlagen.length; i++) if (stand.vorlagen[i].vorlage === kuerzel) return stand.vorlagen[i];
    return null;
  }
  // Kärtchen mit festem Rufnamen (Papa, Mama …) oder ohne Datum gibt es einmal; "Jemand anderes", Patenkind, Freundin öfter
  function einmalig(v) {
    return !v.name_frei;
  }
  function anlassZu(v) {
    for (var i = 0; i < stand.anlaesse.length; i++) if (stand.anlaesse[i].vorlage === v.vorlage) return stand.anlaesse[i];
    return null;
  }
  function anlassTitel(a) {
    if (a.titel) return String(a.titel); // fertig formuliert aus mhsys ("Mamas Geburtstag")
    var v = vorlage(a.vorlage);
    if (a.name && v && v.mit_datum) return a.name + (a.art === "hochzeitstag" ? " · Hochzeitstag" : " · Geburtstag");
    return (v && v.titel) || a.name || "";
  }
  function finderLink(v) {
    if (!finderUrl) return "";
    return finderUrl + (v && v.finder ? (finderUrl.indexOf("?") < 0 ? "?" : "&") + "f=" + encodeURIComponent(v.finder) : "");
  }
  function erinnerungSatz(a) {
    if (a.zu_nah) return "";
    return a.erinnerung_am ? "Passt! Am " + datumLang(a.erinnerung_am) + " sag ma Bescheid." : "Passt! Wir sagen dir rechtzeitig Bescheid.";
  }

  // ---------------------------------------------------------------- Kärtchen
  function kartenZeichnen() {
    if (!stand.vorlagen.length) return;
    karten.textContent = "";
    karten.removeAttribute("aria-busy");
    stand.vorlagen.forEach(function (v) {
      var li = el("li", "mhsys-anl__karte");
      var a = einmalig(v) ? anlassZu(v) : null;
      var knopf = el("button", "mhsys-anl__kartenknopf");
      knopf.type = "button";
      knopf.setAttribute("data-anl-vorlage", v.vorlage);
      knopf.appendChild(el("span", "mhsys-anl__symbol", v.symbol || "📅")).setAttribute("aria-hidden", "true");
      // Gehört das Kärtchen zu genau einem Eintrag (Spotzl, Papa, Mama …), trägt es dessen Titel aus mhsys - mit geändertem
      // Rufnamen also "Geburtstag von Anna" (Inhaber 29.09.2026), auch auf der Rückseite. Die offenen Kärtchen (Jemand
      // anderes, Patenkind, Freundin) legen jedes Mal einen neuen Eintrag an und behalten ihren Titel; die Namen stehen
      // dort in der Liste.
      var titel = a && a.titel ? String(a.titel) : String(v.titel || "");
      // weiches Trennzeichen: "Schwieger-mama" statt mitten im Wort gebrochen (Handy, drei Kärtchen je Reihe)
      knopf.appendChild(el("span", "mhsys-anl__kartentitel", titel.replace(/(Schwieger)(?=[a-zäöü])/g, "$1\u00AD")));
      if (a && v.vorlage === frisch) {
        li.classList.add("is-gedreht");
        knopf.appendChild(el("span", "mhsys-anl__kartenzeile", erinnerungSatz(a) || "Schon bald – jetzt noch bestellen?"));
      } else if (a) {
        li.classList.add("is-eingetragen");
        knopf.appendChild(el("span", "mhsys-anl__kartenzeile", a.tag ? a.tag + ". " + MONATE[a.monat - 1] : "Eingetragen"));
      } else {
        knopf.appendChild(el("span", "mhsys-anl__kartenzeile", v.mit_datum ? "Datum eintragen" : "Erinner mich"));
      }
      li.appendChild(knopf);
      karten.appendChild(li);
    });
    frisch = "";
  }

  karten.addEventListener("click", function (e) {
    var k = e.target.closest ? e.target.closest("[data-anl-vorlage]") : null;
    if (!k) return;
    var v = vorlage(k.getAttribute("data-anl-vorlage"));
    if (!v) return;
    var a = einmalig(v) ? anlassZu(v) : null;
    oeffnen(v, a);
  });

  // ---------------------------------------------------------------- Liste
  // Symbole aus <template data-anl-symbole> der Section (Papierkorb aus snippets/mhsys-icon, Stift im selben Stil)
  var symbole = seite.querySelector("[data-anl-symbole]");
  function symbolKnopf(name, beschriftung) {
    var b = el("button", "mhsys-anl__symbolknopf");
    b.type = "button";
    b.setAttribute("aria-label", beschriftung);
    b.title = beschriftung;
    var vorlageSymbol = symbole && symbole.content.querySelector('[data-anl-symbol="' + name + '"]');
    if (vorlageSymbol) b.appendChild(vorlageSymbol.firstElementChild.cloneNode(true));
    else b.appendChild(el("span", "", beschriftung));
    return b;
  }

  function listeZeichnen() {
    liste.textContent = "";
    meine.hidden = !stand.anlaesse.length;
    stand.anlaesse.forEach(function (a) {
      var v = vorlage(a.vorlage) || {};
      var li = el("li", "mhsys-anl__eintrag");
      li.appendChild(el("span", "mhsys-anl__symbol mhsys-anl__symbol--klein", v.symbol || "📅")).setAttribute("aria-hidden", "true");
      var text = el("div", "mhsys-anl__eintragtext");
      text.appendChild(el("p", "mhsys-anl__eintragtitel", anlassTitel(a)));
      var zeile = a.tag ? a.tag + ". " + MONATE[a.monat - 1] : datumLang(a.naechster_termin);
      text.appendChild(el("p", "mhsys-anl__eintragdatum", zeile));
      if (a.zu_nah) {
        var p = el("p", "mhsys-anl__bald");
        var tage = Number(a.tage_bis);
        p.appendChild(document.createTextNode((tage === 0 ? "Heute ist's so weit" : tage === 1 ? "Schon morgen" : "Schon in " + tage + " Tagen") + " – "));
        var link = el("a", "mhsys-anl__baldlink", "jetzt noch bestellen?");
        link.href = finderLink(v);
        p.appendChild(link);
        text.appendChild(p);
      } else {
        text.appendChild(el("p", "mhsys-anl__eintraghinweis", a.erinnerung_am ? "Erinnerung am " + datumLang(a.erinnerung_am) : "Erinnerung zwei Wochen vorher"));
      }
      li.appendChild(text);
      // Ändern und Löschen als Symbole nebeneinander (Inhaber 29.09.2026), je 44 px Trefferfläche, Name über aria-label
      var knoepfe = el("div", "mhsys-anl__eintragknoepfe");
      var aendern = symbolKnopf("stift", "Ändern");
      aendern.addEventListener("click", function () { oeffnen(v, a); });
      var weg = symbolKnopf("papierkorb", "Löschen");
      weg.classList.add("mhsys-anl__symbolknopf--weg");
      var frage = el("span", "mhsys-anl__wegfrage", "Wirklich weg?");
      frage.hidden = true;
      weg.insertBefore(frage, weg.firstChild);
      weg.addEventListener("click", function () {
        // zweimal tippen: erst fragen, dann löschen
        if (!weg.classList.contains("is-sicher")) {
          weg.classList.add("is-sicher");
          frage.hidden = false;
          weg.setAttribute("aria-label", "Wirklich löschen?");
          weg.title = "Wirklich löschen?";
          return;
        }
        weg.disabled = true;
        proxy("loeschen", { id: a.id })
          .then(function (r) { fehler(""); uebernehmen(r); })
          .catch(function (err) {
            weg.disabled = false;
            // schon weg (anderes Gerät): einfach den Stand neu holen
            if (err.code === "nicht_gefunden") return proxy("liste").then(uebernehmen).catch(function () {});
            fehler(err.message);
          });
      });
      knoepfe.appendChild(aendern);
      knoepfe.appendChild(weg);
      li.appendChild(knoepfe);
      liste.appendChild(li);
    });
  }

  // ---------------------------------------------------------------- Fenster
  function oeffnen(v, a) {
    offen = { vorlage: v.vorlage, id: a ? a.id : null };
    f.symbol.textContent = v.symbol || "📅";
    f.titel.textContent = (a && a.titel) || v.titel || "";
    f.fehler.hidden = true;
    if (!kunde) {
      try { sessionStorage.setItem(SS_OFFEN, v.vorlage); } catch (x) {}
      f.gast.hidden = false;
      f.felder.hidden = true;
      zeigen();
      return;
    }
    f.gast.hidden = true;
    f.felder.hidden = false;
    f.frage.textContent = v.frage || "";
    f.frage.hidden = !v.frage;
    var mitName = v.mit_datum;
    f.namenfeld.hidden = !mitName;
    // Der vorbelegte Rufname ("Spotzl", "Papa") steht als Platzhalter im Feld, nicht als Text: wer hineintippt, ersetzt
    // ihn so, statt ihn zu verlängern - beim Inhaber stand am 29.09.2026 "Spotzl Spotzl" gespeichert. Leer = vorbelegter Name.
    f.name.value = a && a.name && a.name !== v.name ? a.name : "";
    f.name.required = !!v.name_frei;
    f.name.placeholder = v.name_platzhalter || v.name || "";
    f.datumfeld.hidden = !v.mit_datum;
    f.geschlecht.hidden = !v.geschlecht_frage;
    geschlechtSetzen(a && a.geschlecht ? String(a.geschlecht) : "");
    f.tag.value = a && a.tag ? String(a.tag) : "";
    f.monat.value = a && a.monat ? String(a.monat) : "";
    f.fest.hidden = v.mit_datum;
    f.fest.textContent = v.mit_datum ? "" : "Das Datum wissen wir selber – du musst nix eintragen.";
    f.einw.textContent = stand.einw || EINW_ERSATZ;
    f.senden.textContent = a ? "Speichern" : v.mit_datum ? "Erinner mich" : "Ja, erinner mich";
    f.senden.disabled = false;
    zeigen();
  }
  function zeigen() {
    if (typeof fenster.showModal === "function") {
      if (!fenster.open) fenster.showModal();
    } else {
      fenster.setAttribute("open", "");
    }
    // erster Fokus: Gast der Anmelde-Knopf, sonst das erste Feld, das noch leer ist
    var erstes = seite.querySelector("[data-anl-anmelden-link]");
    if (kunde) {
      if (!f.namenfeld.hidden && f.name.required && !f.name.value) erstes = f.name;
      else if (!f.datumfeld.hidden) erstes = f.tag;
      else erstes = f.senden;
    }
    if (erstes) erstes.focus();
  }
  // weiblich / männlich: freiwillig, ein Knopf oder keiner; nochmal tippen wählt ab
  function geschlechtSetzen(g) {
    f.geschlecht.querySelectorAll("[data-anl-g]").forEach(function (b) {
      b.setAttribute("aria-pressed", String(b.getAttribute("data-anl-g") === g));
    });
  }
  function geschlechtLesen() {
    var an = f.geschlecht.querySelector('[data-anl-g][aria-pressed="true"]');
    return an ? an.getAttribute("data-anl-g") : "";
  }
  f.geschlecht.addEventListener("click", function (e) {
    var b = e.target.closest ? e.target.closest("[data-anl-g]") : null;
    if (!b) return;
    geschlechtSetzen(b.getAttribute("aria-pressed") === "true" ? "" : b.getAttribute("data-anl-g"));
  });

  function schliessen() {
    if (typeof fenster.close === "function" && fenster.open) fenster.close();
    else fenster.removeAttribute("open");
  }
  seite.querySelector("[data-anl-zu]").addEventListener("click", schliessen);
  // Klick auf den Schleier (außerhalb des Formulars) schließt
  fenster.addEventListener("click", function (e) { if (e.target === fenster) schliessen(); });
  fenster.addEventListener("close", function () { offen = null; });

  function formFehler(text) {
    f.fehler.textContent = text;
    f.fehler.hidden = false;
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    if (!offen || !kunde) return;
    var v = vorlage(offen.vorlage);
    if (!v) return;
    var daten = { vorlage: v.vorlage };
    if (offen.id) daten.id = offen.id;
    if (v.mit_datum) {
      var name = f.name.value.replace(/\s+/g, " ").trim() || (v.name_frei ? "" : String(v.name || ""));
      var tag = Number(f.tag.value);
      var monat = Number(f.monat.value);
      if (v.name_frei && !name) return formFehler("Wie heißt er oder sie? Ein Rufname reicht.");
      if (!tag || !monat) return formFehler("Magst du noch Tag und Monat auswählen?");
      if (tag > TAGE_IM_MONAT[monat - 1]) return formFehler("Den " + tag + ". " + MONATE[monat - 1] + " gibt's leider ned.");
      daten.name = name;
      daten.tag = tag;
      daten.monat = monat;
      if (v.geschlecht_frage) daten.geschlecht = geschlechtLesen();
    }
    f.senden.disabled = true;
    f.fehler.hidden = true;
    proxy("speichern", daten)
      .then(function (r) {
        fehler("");
        if (einmalig(v)) frisch = v.vorlage;
        uebernehmen(r);
        schliessen();
        var k = karten.querySelector('[data-anl-vorlage="' + v.vorlage + '"]');
        if (k) k.focus();
      })
      .catch(function (err) {
        f.senden.disabled = false;
        if (err.status === 401 || err.code === "anmeldung") { kunde = false; oeffnen(v, null); return; }
        formFehler(err.message);
      });
  });

  // ---------------------------------------------------------------- Start
  function nachAnmeldungOeffnen() {
    var k = "";
    try { k = sessionStorage.getItem(SS_OFFEN) || ""; sessionStorage.removeItem(SS_OFFEN); } catch (x) {}
    var v = k && vorlage(k);
    if (v && kunde) oeffnen(v, einmalig(v) ? anlassZu(v) : null);
  }

  proxy(kunde ? "liste" : "vorlagen")
    .then(function (a) {
      fehler("");
      uebernehmen(a);
      nachAnmeldungOeffnen();
    })
    .catch(function (err) {
      // angemeldet, aber der Proxy kennt die Sitzung nicht (z. B. abgelaufen): wie ein Gast weiter
      if (kunde && (err.status === 401 || err.code === "anmeldung")) {
        kunde = false;
        return proxy("vorlagen").then(uebernehmen);
      }
      throw err;
    })
    .catch(function (err) {
      karten.removeAttribute("aria-busy");
      karten.textContent = "";
      fehler(err && err.message ? err.message : FEHLER_ALLG);
    });
})();
